"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Subscriptions = require("./Subscriptions");
Object.keys(_Subscriptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Subscriptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Subscriptions[key];
    }
  });
});
